import { faAngleDown, faArrowRightFromBracket, faCogs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState } from "react";
import { DropdownToggle, DropdownMenu, Nav, NavItem, UncontrolledButtonDropdown } from 'reactstrap';
import { useSelector } from "react-redux";
import AvatarRound from "../../../components/AvatarRound";
import { Link } from "react-router-dom";
import useOutsideClick from "../../../util/useOutsideClick"
import { setMenuUserShow } from "../../../reducers/models/menuData";
import { useDispatch } from "react-redux";


function UserInfo() {

    const dispatch = useDispatch()

    const stateSetting = useSelector((state) => state.setting);//Настройки приложения
    const stateMenu = useSelector((state) => state.menuData);//Настройки приложения

    const [name, setName] = useState('');
    const [roleName, setRoleName] = useState('');
    const [avatar, setAvatar] = useState(null);

    useEffect(() => {
        if (stateSetting.user !== null) {
            if (stateSetting.user.Avatar_Small !== null) {
                setAvatar(stateSetting.user.Avatar_Small);
            }
            setName(stateSetting.user.Name);
        }
        if (stateSetting.companyService !== null) {
            setRoleName(stateSetting.companyService.Name_Role);
        }
    }, [stateSetting.user, stateSetting.companyService]);


    //Скроет меню
    const outsideClick = useOutsideClick(() => {
        dispatch(setMenuUserShow({ data: false }));
    });

    function exit() {
        //Кроссбраузерное удаление физически куки не работает. Как вариант использовать редирект на основной сайт.
        return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN + '/exit?redirect=' + process.env.REACT_APP_DOMAIN_SERVICE);
    }

    return (
        <>
            <Fragment>
                <div className="header-btn-lg pe-0">
                    <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                            <div className="widget-content-left" ref={outsideClick}>
                                <UncontrolledButtonDropdown isOpen={stateMenu.menuUserShow}>
                                    <DropdownToggle color="link" className="p-0" onClick={() => dispatch(setMenuUserShow({ data: !stateMenu.menuUserShow }))}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <AvatarRound img={avatar} width={42} name={name.charAt(0)} />
                                            <FontAwesomeIcon className="ms-2 opacity-8" icon={faAngleDown} />
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                                        <Nav vertical>
                                            {
                                                /*
                                                  <NavItem>
                                                <Link to="/lk/billing" className='nav-link' onClick={() => dispatch(setMenuUserShow({ data: false }))}>
                                                    <i className="mr-5"><FontAwesomeIcon icon={faCreditCard} /></i>
                                                    Оплата
                                                </Link>
                                            </NavItem>
                                                */
                                            }

                                            <NavItem>
                                                <Link to="/lk/setting" className='nav-link' onClick={() => dispatch(setMenuUserShow({ data: false }))}>
                                                    <i className="mr-5"><FontAwesomeIcon icon={faCogs} /></i>
                                                    Настройки
                                                </Link>
                                            </NavItem>

                                            <NavItem>
                                                <Link className='nav-link' onClick={() => { dispatch(setMenuUserShow({ data: false })); exit() }}>
                                                    <i className="mr-5"><FontAwesomeIcon icon={faArrowRightFromBracket} /></i>
                                                    Выход
                                                </Link>
                                            </NavItem>
                                        </Nav>
                                    </DropdownMenu>
                                </UncontrolledButtonDropdown>
                            </div>
                            <div className="widget-content-left  ms-3 header-user-info">
                                <div className="widget-heading">
                                    {name}
                                </div>
                                <div className="widget-subheading">
                                    {roleName}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        </>
    )
}

export default UserInfo;